import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import Button from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import Select from "shared/@forms/Select";
import TextArea from "shared/@forms/TextArea";
import { useAwards } from "./../../External/useAwards";
import { useEditGracePeriod } from "./useEditGracePeriod";

const EditGracePeriod = (props) => {
  const {
    iboNumber,
    setIboNumber,

    graceAward,
    setGraceAward,

    newAward,
    setNewAward,

    periodStart,
    setPeriodStart,

    periodEnd,
    setPeriodEnd,

    notes,
    setNotes,

    submit,
  } = useEditGracePeriod(props.record.id, props.record, props.refresh);

  const { awards, loading, isWaiting } = useAwards();

  const { currentAward } = graceAward;

  const [award, setAward] = useState();
  const [awardNew, setAwardNew] = useState();

  useEffect(() => {
    awards && setAward(awards[graceAward]);
    awards && setAwardNew(awards[newAward]);
  }, [awards, graceAward, newAward]);

  return (
    <>
      <form style={{ width: "500px" }}>
        <div>
          <h3>Ibo Number</h3>
          <TextInput
            value={iboNumber}
            onChange={(e) => {
              setIboNumber(e.target.value);
            }}
          />
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Grace Award</h3>
            <Select
              style={{ minWidth: "235px" }}
              onChange={(e) => {
                setGraceAward(e.target.value);
              }}
            >
              {award ? <option value={award.id}>{award.wwgDesc}</option> : null}
              {award
                ? awards.map((a, i) => {
                    return award.id === a.id ? null : (
                      <option key={i} value={a.id - 1}>
                        {a.wwgDesc}
                      </option>
                    );
                  })
                : null}
            </Select>
          </div>

          <div>
            <h3>New Award</h3>
            <Select
              style={{ minWidth: "235px" }}
              onChange={(e) => {
                setNewAward(e.target.value);
              }}
            >
              {awardNew ? (
                <option value={awardNew.id}>{awardNew.wwgDesc}</option>
              ) : null}
              {awardNew
                ? awards.map((a, i) => {
                    return awardNew.id === a.id ? null : (
                      <option key={i} value={a.id - 1}>
                        {a.wwgDesc}
                      </option>
                    );
                  })
                : null}
            </Select>
          </div>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Period Start</h3>
            <TextInput
              defaultValue={new Date(periodStart).toLocaleDateString()}
              className={styles.modalTextInput}
              onChange={(e) => {
                setPeriodStart(new Date(e.target.value));
              }}
            />
          </div>

          <div>
            <h3>Period End</h3>
            <TextInput
              defaultValue={new Date(periodEnd).toLocaleDateString()}
              className={styles.modalTextInput}
              onChange={(e) => {
                setPeriodEnd(new Date(e.target.value));
              }}
            />
          </div>
        </div>

        <div className={styles.padding}>
          <h3>Notes</h3>
          <TextArea
            value={notes}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
          />
        </div>

        <div className={styles.buttonRow}>
          <Button className={styles.cancelButton} onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            className={styles.addButton}
            onClick={(e) => {
              e.preventDefault();
              submit();
            }}
          >
            Save Grace Period
          </Button>
        </div>
      </form>
    </>
  );
};
export default EditGracePeriod;
